module.exports = __webpack_public_path__ + "static/img/right.125d1b46.png";